<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>การศึกษา</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" scrollable persistent max-width="600px">
        <v-btn slot="activator" color="primary" dark class="mb-2" v-if="hasAccess(allowedRoles)">เพิ่ม</v-btn>
        <v-card>
          <v-card-title>
            <span class="title">{{ formTitle }}</span>
            <v-spacer></v-spacer>
            <v-btn flat icon color="grey" @click="close">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-form v-model="valid" ref="form" lazy-validation enctype="multipart/form-data">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 md12>
                    <v-text-field 
                      v-model="editedItem.year" 
                      mask="####" 
                      label="ปีการศึกษา"
                      :rules="[rules.required]"
                      required>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md12>
                  <v-select
                    :items="educationLevelItems"
                    v-model="editedItem.educationLevel"
                    label="ระดับการศึกษา"
                    item-text="nameTh"
                    single-line
                    return-object
                    :rules="[rules.required]"
                    required
                  ></v-select>
                  </v-flex>
                  <v-flex xs12 md12>
                    <v-text-field v-model="editedItem.name" label="ชื่อ" :rules="[rules.required]"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md12>
                    <v-text-field v-model="editedItem.branch" label="สาขา"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md12>
                    <v-text-field v-model="editedItem.institution" label="สถาบัน"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md12>
                    <v-text-field v-model="editedItem.country" label="ประเทศ"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6 v-if="editedItem.attachmentTranscripts">
                    <v-list subheader>
                      <v-subheader class="blue-grey--text"><strong>รายการเอกสารแนบ</strong></v-subheader>

                      <v-list-tile
                        v-for="(doc, index) in editedItem.attachmentTranscripts"
                        :key="doc.filename"
                        avatar
                        @click=""
                      >
                        <v-list-tile-content>
                          <v-list-tile-title>
                          <a :href="download(doc)">{{doc.filename}}</a>
                        </v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-btn icon ripple @click.native="onDeleteFile(doc, index)">
                            <v-icon color="grey lighten-1">delete</v-icon>
                          </v-btn>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list>
                  </v-flex>
                  <v-flex xs12 md12>
                    <div align="right">
                      <span class="grey--text caption"><strong>ประเภทไฟล์ที่สามารถอัพโหลด ได้แก่ .png, .jpg, .jpeg, .gif, .pdf, .xls, .xlsx, .doc, .docx | สูงสุด 3 ไฟล์ | ขนาดไฟล์แต่ละไฟล์ไม่เกิน 1MB</strong></span>
                    </div>
                    <vue-dropzone 
                      ref="myVueDropzone" 
                      id="dropzone" 
                      :options="dropzoneOptions" 
                      @vdropzone-file-added="fileAdded" 
                      @vdropzone-success="uploadSuccess" 
                      @vdropzone-removed-file="removeFile">
                    </vue-dropzone>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="grey white--text" @click="close">ยกเลิก</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="green white--text" @click="save">บันทึก</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="personData.educations"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.year }}</td>
        <td class="text-xs-left">{{ props.item.educationLevel.shortNameTh }}</td>
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.branch }}</td>
        <td class="text-xs-left">{{ props.item.institution }}</td>
        <td class="text-xs-left">{{ props.item.country }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
            v-if="hasAccess(allowedRoles)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item)"
            v-if="hasAccess(allowedRoles)"
          >
            delete
          </v-icon>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { hasAccessMixin } from '@/mixins/hasAccessMixin'
import vue2Dropzone from 'vue2-dropzone'
import swal from 'sweetalert2'

export default {
  mixins: [ hasAccessMixin ],
  props: [ 'personId' ],
  components: {
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE'],
      valid: false,
      dialog: false,
      destroyDropzone: false,
      headers: [
        { text: 'ปีการศึกษา', value: 'year' },
        { text: 'ระดับการศึกษา', value: 'educationLevel.shortNameTh' },
        { text: 'ชื่อ', value: 'name' },
        { text: 'สาขา', value: 'branch' },
        { text: 'สถาบัน', value: 'institution' },
        { text: 'ประเทศ', value: 'country' },
        { text: 'Actions', value: 'name', sortable: false }
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      rules: {
        required: (value) => !!value || 'ไม่สามารถเป็นค่าว่าง'
      },
      dropzoneOptions: {
        url: this.$store.getters['person/uploadEducationUrl'],
        headers: { 'Authorization': ['Bearer', this.$store.getters.token].join(' ') },
        method: 'post',
        autoProcessQueue: false,
        addRemoveLinks: true,
        createImageThumbnails: true,
        acceptedFiles: 'image/*, .doc, .docx, .xls, .xlsx, .pdf, application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain',
        maxFiles: 3,
        uploadMultiple: true,
        parallelUploads: 3,
        maxFilesize: 1,
        params: {
          educationId: null
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      educationLevelItems: 'person/educationLevelItems',
      personData: 'person/personData'
    }),
    formTitle () {
      return this.editedIndex === -1 ? 'เพิ่มรายการ' : 'แก้ไขรายการ'
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  methods: {
    fileAdded (file) {
      console.log("fileAdded", file)
    },
    uploadSuccess (file, response) {
      console.log("uploadSuccess", response)
    },
    removeFile (file, error, xhr) {
      console.log("removeFile", file)
    },
    editItem (item) {
      this.editedIndex = this.personData.educations.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      const index = this.personData.educations.indexOf(item)
      swal({
        title: 'คุณแน่ใจ?',
        text: "คุณจะไม่สามารถเรียกคืนข้อมูลได้อีก!",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่, ฉันต้องการลบข้อมูลนี้!'
      }).then((result) => {
        if (result.value) {
          const dispatch = 'person/deleteItem'
          item.dispatch = 'educations'
          this.$store.dispatch(dispatch, item)
            .then((response) => {
              this.$store.dispatch('person/fetchPerson', this.personId)
              this.close()
            }).catch((error)=>{
              console.log('initialize', error)
              swal('เกิดข้อผิดพลาด!', error.message, 'error')
            })
          swal(
            'ลบรายการ!',
            'คุณได้ทำการลบรายการเรียบร้อยแล้ว',
            'success'
          )
        }
      })
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.$refs.myVueDropzone.removeAllFiles()
      }, 300)
    },
    save () {
      if (this.$refs.form.validate()) {
        const dispatch =  this.editedIndex === -1 ? 'person/createItem' : 'person/updateItem'
        console.log('dispatch', dispatch)
        this.editedItem.person = this.personId
        this.editedItem.dispatch = 'educations'
        this.$store.dispatch(dispatch, this.editedItem)
          .then((response) => {
            console.log('onSave:', response )
            this.dropzoneOptions.params.educationId = response.data.id
            this.$refs.myVueDropzone.processQueue()
            swal({
                title: 'Success!',
                type: 'success'
              }).then(response => {
                this.$store.dispatch('person/fetchPerson', this.personId)
                this.close()
              })         
          }).catch((error)=>{
            console.log('error', error)
            swal('Error!', error.message, 'error')
          })
        this.close()
      }
    },
    download (doc) {
      return `${this.$store.getters['attachmentDocument/downloadUrl']}/${doc.id}?access_token=${this.$store.getters.token}`
    },
    onDeleteFile (doc, index) {
      console.log('delete:', doc )
      // console.log('index:', index )
      const idx = this.editedItem.attachmentTranscripts.indexOf(doc)
      console.log('idx:', idx )
      this.editedItem.attachmentTranscripts.splice(index, 1)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/person/shows/education/index.vue